import { MitreTechniqueId, Severity } from '@bartizo/shared';
import type { EventFilters } from '../api/events.js';

/** What one server's Events tab filters by, and the query that makes of it. */

export const EVENT_RANGES = [
  { value: '24', label: 'Last day' },
  { value: '168', label: 'Last week' },
  { value: '720', label: 'Last 30 days' },
  /** Named rather than empty, because an absent parameter means the default. */
  { value: 'all', label: 'All time' },
] as const;

export interface EventFilterState {
  severity: string;
  category: string;
  state: string;
  /** Hours back, or `all`. */
  hours: string;
  attack: string;
}

export const NO_EVENT_FILTERS: EventFilterState = {
  severity: '',
  category: '',
  state: '',
  hours: 'all',
  attack: '',
};

/** The query for a state, from a window start pinned by the caller (see `EventsPage`). */
export function toEventFilters(state: EventFilterState, from: string | undefined): EventFilters {
  const severity = Severity.safeParse(state.severity);
  const technique = MitreTechniqueId.safeParse(state.attack.trim().toUpperCase());
  return {
    ...(severity.success ? { min_severity: severity.data } : {}),
    ...(state.category === '' ? {} : { category: state.category }),
    ...(state.state === 'open' ? { acknowledged: false } : {}),
    ...(state.state === 'done' ? { acknowledged: true } : {}),
    ...(technique.success
      ? { technique: technique.data }
      : state.attack.trim() === ''
        ? {}
        : { tactic: state.attack.trim() }),
    ...(from === undefined ? {} : { from }),
  };
}

export const anyEventFilter = (state: EventFilterState): boolean =>
  state.severity !== '' ||
  state.category !== '' ||
  state.state !== '' ||
  state.attack !== '' ||
  state.hours !== NO_EVENT_FILTERS.hours;
